<template>
    <div class="slider-container">
        <div class="slider-bg-success" :style="{width: progress + '%'}"/>
        <div class="slider-bg" :style="{width: progressLeft + '%'}"/>
        <input step="1" min="1" :max="max" v-bind:value="sliderValue" @input="onChangeValue($event, false)" @mouseup="onChangeValue($event, true)" @touchend="onChangeValue($event, true)" type="range" />
    </div>
</template>

<script>
    export default {
        name: 'SliderProgress',
        props: ['newValue', 'max'],
        data() {
            return {
                sliderValue: 1
            }
        },
        computed: {
            progress() {
                return ((this.sliderValue-1)/(this.max-1))*100;
            },
            progressLeft() {
                return 100-(((this.sliderValue-1)/(this.max-1))*100)
            }
        },
        mounted() {
            this.sliderValue = this.newValue;
        },
        watch: {
            newValue(_new, old) {
                this.sliderValue = _new;
            }
        },
        methods: {
            onChangeValue(event, emit) {
                event.stopPropagation();
                this.sliderValue = parseInt(event.target.value);

                this.$emit('slider-progress-display-update', this.sliderValue);
                
                if(emit) {
                    this.$emit('slider-progress-update', this.sliderValue);
                }
            }
        }
    }
</script>

<style lang="scss">
@import "src/css/vars.scss";

$sliderHeight:'5px';

.slider-container {
    // background: $background-color;
    position: absolute;
    width: 100%;
    top: -6px;
    left: 0;
    height: 12px;
    overflow: hidden;

    .slider-bg-success {
        float: left;
        background: $success-color;   
        height: 5px;
        margin-top:3px;
    }

    .slider-bg {
        float: left;
        background: $background-color-dark;
        height: 5px;
        margin-top:3px;
    }

    /* CLEAR DEFAULT STYLES */
    input[type=range] {
        position: relative;
        top: -16px;

        -webkit-appearance: none; /* Hides the slider so that custom slider can be made */
        width: 100%; /* Specific width is required for Firefox. */
        background: transparent; /* Otherwise white in Chrome */
    }

    input[type=range]::-webkit-slider-thumb {
        -webkit-appearance: none;
    }

    input[type=range]:focus {
        outline: none; /* Removes the blue border. You should probably do some kind of focus styling for accessibility reasons though. */
    }

    input[type=range]::-ms-track {
        width: 100%;
        cursor: pointer;

        /* Hides the slider so custom styles can be added */
        background: transparent; 
        border-color: transparent;
        color: transparent;
    }

    /* Special styling for WebKit/Blink */
    input[type=range]::-webkit-slider-thumb {
        -webkit-appearance: none;
        border: none;
        height: 10px;
        width: 10px;
        border-radius: 1px;
        background: $success-color-darker;
        cursor: pointer;
        // margin-top: -22px; /* You need to specify a margin in Chrome, but in Firefox and IE it is automatic */
    }

    /* All the same stuff for Firefox */
    input[type=range]::-moz-range-thumb {
        border: none;
        height: 10px;
        width: 10px;
        border-radius: 1px;
        background: $success-color-darker;
        cursor: pointer;
    }

    /* All the same stuff for IE */
    input[type=range]::-ms-thumb {
        border: none;
        height: 10px;
        width: 10px;
        border-radius: 1px;
        background: $success-color-darker;
        cursor: pointer;
    }
}
</style>